import { Grid, GridItem, Text } from '@chakra-ui/react'
import dateFormat from 'functions/dateFormat'
import React from 'react'

interface Props {
    created_at: string
    glucose_value: string
    date: string
    time: string
    status: string
    gestational_age: string
    weight: String
    observation: string
}

const GlucoseValues = ({ created_at, glucose_value, date, time, status, gestational_age, weight, observation }: Props) => {
    return (
        <>
            <Text>Data do registro: {dateFormat(created_at, "dd/MM/yyyy HH:mm:ss")}</Text>
            <Grid gap={2} templateColumns={{ sm: "1fr", md: "repeat(2, 1fr)" }}>
                <GridItem><Text fontSize="md" fontWeight="bold">Valor da Glicemia (mg/dL): {glucose_value}</Text></GridItem>
                <GridItem><Text fontSize="md" fontWeight="bold">Data e hora: {date} {time}</Text></GridItem>
                <GridItem><Text fontSize="md" fontWeight="bold">Situação: {status}</Text></GridItem>
                <GridItem><Text fontSize="md" fontWeight="bold">Idade gestacional atualizada (em semanas): {gestational_age}</Text></GridItem>
                <GridItem><Text fontSize="md" fontWeight="bold">Peso (em Kg): {weight}</Text></GridItem>
                <GridItem><Text fontSize="md" fontWeight="bold">Observação: {observation}</Text></GridItem>
            </Grid>
        </>
    )
}

export default GlucoseValues